export default __webpack_public_path__ + "static/media/head04_th_sp.02832655.png";